import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import currencies from 'shared/constants/json/currency.json';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './InlineAdvertsBlock.css';
// import AdvertCard from '../AdvertCard/AdvertCard';
import AdvertCarCard from 'desktop/components/AdvertCarCard/AdvertCarCard';

const uah = currencies.find(item => item.slug === 'uah');
const IMAGE_WIDTH = 237;

class InlineAdvertsBlock extends React.Component {
  static propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    currency: PropTypes.shape(),
    rows: PropTypes.number,
    lensEvent: PropTypes.string,
    itemsInLine: PropTypes.number,
  };

  static defaultProps = {
    rows: 1,
    itemsInLine: 3,
    currency: uah,
    lensEvent: '',
  };

  getImageStyles = () => ({
    height: parseInt(582 / this.props.itemsInLine, 10),
  });

  render() {
    const { items, rows, itemsInLine, currency, lensEvent } = this.props;

    if (!items.length) {
      return null;
    }

    const widthStyle = {
      width: `${100 / itemsInLine}%`,
    };

    const showedItems = items.slice(0, rows * itemsInLine);

    const advertClassName = cx(s.advert, {
      [s.multirow]: rows > 1,
    });

    return (
      <div className={s.root}>
        <div className={s.row}>
          {showedItems.map((item, idx) =>
            <AdvertCarCard
              key={item.id}
              advert={item}
              index={idx}
              advertClassName={advertClassName}
              advertStyle={widthStyle}
              // imageStyle={this.getImageStyles(item)}
              currency={currency}
              width={IMAGE_WIDTH}
              lensEvent={lensEvent}
            />,
          )}
        </div>
      </div>
    );
  }
}

export default withStyles(s)(InlineAdvertsBlock);



// WEBPACK FOOTER //
// ./src/desktop/components/InlineAdvertsBlock/InlineAdvertsBlock.js